import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class ResmarkButton extends Component
{
    constructor(props) {
        super(props);
        
    }
    
    render()
    {
        const { agency, agent_id, className, reseller_product } = this.props;
        
        return (
            <div>
                <rm-cart-button 
                    product-code={reseller_product.productCode} 
                    agent-id={agent_id}
                    entity-id={agency.agencyId}
                    price-code="Default" 
                    button-label="Book Now"
                    class={this.props.className}>
                </rm-cart-button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Shared/ResmarkButton.js